<fc-modal [id]="modalId" [options]="options">
    <div class="fc-create-store-dialog">
        <div class="fc-store-creation-dialog-container">
            <div class="fc-store-page">
                <div class="fc-store-page-body">
                    <div class="fc-store-creation-dialog-title">
                        {{ 'MANAGE_CLARA.BRANCH_OVERVIEW.CREATE_NEW' | translate }}
                    </div>
                    <p>
                        {{ 'STORE_CREATION.MODAL.INTRO' | translate }}
                    </p>

                    <fc-clara-address-form [addressForm]="addressForm"></fc-clara-address-form>

                    <div class="fc-create-store-dialog-gln-forms">
                        <div class="fc-create-store-dialog-gln-title-wrapper">
                            <span class="fc-create-store-dialog-gln-title">{{
                                'MANAGE_STORE.GLN_TITLE' | translate
                            }}</span>
                            <span
                                class="fc-create-store-dialog-info-icon"
                                [matTooltip]="'MANAGE_STORE.GLN_DESCRIPTION' | translate"
                                matTooltipClass="large-tooltip-text"
                            >
                                <fcp-icon [icon]="['fal', 'info-circle']"></fcp-icon>
                            </span>
                        </div>
                        <fc-clara-gln-form [glnForm]="glnForm"></fc-clara-gln-form>
                    </div>
                </div>
            </div>
        </div>

        <div class="fc-create-store-dialog-action-buttons">
            <button *ngIf="options.showCancelButton" fcp-outlined-button (click)="onReject.emit(); close()">
                {{ 'cancel' | translate }}
            </button>

            <button fcp-button [disabled]="!isFormValid" (click)="submitBranch()">
                {{ 'accept' | translate }}
            </button>
        </div>

        <div *ngIf="storeService.hasError | async" class="fc-error-message">
            <span>{{ 'TEXT_UNKNOWN_ERROR' | translate }}</span>
        </div>
    </div>
</fc-modal>
